﻿interface Preferences extends IndexedType<any> {
	sidebarOpened: boolean;
}

const values: Preferences = <any>{},
	cookieName = "cmn.preferences",
	cookieValue = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(cookieName).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;

if (cookieValue) {
	for (const value of cookieValue.split("&")) {
		let sections: any[] = value.split("=");

		if (sections[1].match(/^(true)|(false)$/)) {
			sections[1] = sections[1].toLowerCase() === "true";
		} else if (!isNaN(sections[1])) {
			sections[1] = parseFloat(sections[1]);
		}

		values[sections[0]] = sections[1];
	}
}

export const preferences: Preferences = new (class PreferenceImpl implements Preferences {
	get sidebarOpened() {
		return !!values.sidebarOpened;
	}

	set sidebarOpened(value: boolean) {
		values.sidebarOpened = value;

		PreferenceImpl.update();
	}

	static update() {
		let parts = [cookieName, "="];

		for (const key in values) {
			if (values.hasOwnProperty(key)) {
				parts.push(`${key}=${values[key]}`);
			}
		}

		parts.push("; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/");

		document.cookie = parts.join("");
	}
});
